module.exports = __webpack_public_path__ + "img/feedback.da59c509.svg";